import React from "react";
import { Center, CenterProps, Icon } from "@chakra-ui/react";
import { Headphones } from "lucide-react";

export type AudiobookBadgeSize = "sm" | "md" | "lg";

export interface AudiobookBadgeProps extends CenterProps {
  size?: AudiobookBadgeSize;
}

const sizeConfig: Record<
  AudiobookBadgeSize,
  {
    boxSize: CenterProps["boxSize"];
    iconBoxSize: CenterProps["boxSize"];
    top: CenterProps["top"];
    right: CenterProps["right"];
  }
> = {
  sm: {
    boxSize: "1.5rem",
    iconBoxSize: "0.875rem",
    top: "0.375rem",
    right: "0.375rem",
  },
  md: {
    boxSize: "2rem",
    iconBoxSize: "1.125rem",
    top: "0.5rem",
    right: "0.5rem",
  },
  lg: {
    boxSize: { base: "2.5rem", md: "3rem" },
    iconBoxSize: { base: "1.375rem", md: "1.625rem" },
    top: { base: "0.75rem", md: "1rem" },
    right: { base: "0.75rem", md: "1rem" },
  },
};

export const AudiobookBadge: React.FC<AudiobookBadgeProps> = ({
  size = "md",
  ...rest
}) => {
  const config = sizeConfig[size] ?? sizeConfig.md;

  return (
    <Center
      position="absolute"
      top={config.top}
      right={config.right}
      boxSize={config.boxSize}
      borderRadius="full"
      bg="blackAlpha.700"
      backdropFilter="blur(8px)"
      color="white"
      border="1px solid"
      borderColor="whiteAlpha.400"
      boxShadow="0 3px 10px rgba(0, 0, 0, 0.45)"
      pointerEvents="none"
      zIndex={2}
      aria-label="Аудіокнига"
      title="Аудіокнига"
      {...rest}
    >
      <Icon as={Headphones} boxSize={config.iconBoxSize} />
    </Center>
  );
};

export default AudiobookBadge;
